<template>
  <div>
    <div v-show="loading">
      <Loading />
    </div>
    <div v-if="errored">
      <ErrorPage />
    </div>
    <div v-else-if="notfound">
      <NotFound titulo="Informações do Estacionamento" />
    </div>
    <div v-else class="food-page-section content-size section-home-noradius">
      <div class="wrap-food-recipe">
        <div class="heading-page-item">{{ textoTitulo }}</div>

        <div class="section-news-page">
          <div class="news-wrap">
            <div v-if="exibeImagem(caminhoImagem)">
              <Imagem :caminhoImagem="caminhoImagem"></Imagem>
              <br />
            </div>
            <h5>{{ $t('Descricao') }}</h5>
            <p class="news-content">{{ textoDescricao }}</p>
            <br />
            <h5>{{ $t('Funcionamento') }}</h5>
            <p class="news-content">{{ textoHorarioFuncionamento }}</p>
            <br />
            <h5>{{ $t('Valores') }}</h5>
            <p class="news-content">{{ textoValores }}</p>

            <!-- <br />
            <h5>Peça seu Veículo</h5>
            <div class="tab-comment">
              <form class="form-inline">
                <div class="form-group mx-sm-3 mb-2">
                  <input
                    size="12"
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="7"
                    id="placa"
                    placeholder="ABC1234"
                  />
                </div>
                <div class="space">
                  <button type="submit" class="btn btn-primary btn-sm mb-2">Solicitar</button>
                </div>
              </form>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorPage from "@/components/template/ErrorPage";
import NotFound from "@/components/template/NotFound";
import Loading from "@/components/template/Loading";
import Imagem from "@/components/Imagem";

import FunctionsMixin from '@/utils/functionsMixin.js'
import modulePagina from '@/store/paginas/modulePagina.js';

export default {
  name: "Cardapios-Estacionamento",

  components: {
    ErrorPage,
    NotFound,
    Loading,
    Imagem
  },

  mixins: [FunctionsMixin],

  data() {
    return {
      loading: false,
      errored: false
    };
  },

  computed: {
    stateEstacionamento() {
      return this.$store.state.modulePaginas.estacionamento
    },
    notfound() {
      return this.stateEstacionamento ? false : true
    },
    caminhoImagem() {
      return this.stateEstacionamento ? this.stateEstacionamento.imagem : ''
    },
    textoTitulo() {
      return this.stateEstacionamento
        ? (this.stateEstacionamento.tituloIdioma ? this.stateEstacionamento.tituloIdioma[this.$i18n.locale] : this.stateEstacionamento.titulo)
        : ''
    },
    textoDescricao() {
      return this.stateEstacionamento
        ? (this.stateEstacionamento.descricaoIdioma ? this.stateEstacionamento.descricaoIdioma[this.$i18n.locale] : this.stateEstacionamento.descricao)
        : ''
    },
    textoHorarioFuncionamento() {
      return this.stateEstacionamento
        ? (this.stateEstacionamento.horarioFuncionamentoIdioma ? this.stateEstacionamento.horarioFuncionamentoIdioma[this.$i18n.locale] : this.stateEstacionamento.horarioFuncionamento)
        : ''
    },
    textoValores() {
      return this.stateEstacionamento ? this.stateEstacionamento.valores : ''
    }
  },

  created() {
    if (!modulePagina.isRegistered) {
      this.$store.registerModule('modulePaginas', modulePagina)
      modulePagina.isRegistered = true
    }

    if (!this.stateEstacionamento) {
      const data = {
        estabelecimentoId: this.$store.state.dadosEstabelecimento.estabelecimentoId,
        tipoPagina: 'estacionamento'
      }
      this.$store.dispatch('modulePaginas/fetchPaginaEstacionamento', data)
    }
  }
};
</script>

<style>
.submit-btn {
  padding-top: 15px;
}

.space {
  padding-left: 8px;
}
</style>
